import { useState, useEffect } from 'react'
import { getTrainingListExpStatusAPI } from '../services/certificate'

function UseExpire() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTrainingListExpStatusAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.id, label: d.exp_status }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseExpire
